import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const PaperPlaneIcon = ({
    size = 16,
    color = 'currentFill'
}: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 16 16"
        fill={color}
        xmlns="http://www.w3.org/2000/svg">
        <path clipRule="evenodd"
            d="M15.48.423a.75.75 0 0 1 .255.724l-2.8 14a.75.75 0 0 1-1.186.453l-3.982-2.987-2.465 2.875A.75.75 0 0 1 3.982 15l.005-5.598a.75.75 0 0 1 .333-.623l4.196-2.803a.75.75 0 1 1 .833 1.248L6.034 9.438l5.663 4.248 2.296-11.475L2.517 6.8l.801.6a.75.75 0 1 1-.9 1.2L.55 7.201A.75.75 0 0 1 .72 5.903l14-5.6a.75.75 0 0 1 .758.12Zm-9.994 10.48-.002 2.068 1.08-1.26-1.078-.809Z"/>
    </svg>
);
PaperPlaneIcon.displayName = 'PaperPlaneIcon';
export default PaperPlaneIcon;
